import axios from '@/utils/request';

// 获取收藏夹列表
export const getFavorites = (data: any) => {
  return axios.request({
    url: 'Favorites/GetFavorites',
    method: 'GET',
    params: data,
  });
};

// 新增&编辑收藏夹
export const postFavorites = (data: any) => {
  return axios.request({
    url: 'Favorites/PostFavorites',
    method: 'POST',
    data,
  });
};

// 删除收藏夹
export const deleteFavorites = (data: any) => {
  return axios.request({
    url: 'Favorites/DeleteFavorites',
    method: 'POST',
    data,
  });
};

// 获取收藏夹详情
export const getFavoritesDetails = (data: any) => {
  return axios.request({
    url: 'Favorites/GetFavoritesDetails',
    method: 'GET',
    params: data,
  });
};

// 获取收藏夹内容
export const getFavoritesRelation = (data: any) => {
  return axios.request({
    url: 'Favorites/GetFavoritesRelation',
    method: 'GET',
    params: data,
  });
};

// 获取我的收藏夹树
export const getFavoritesTree = (data: any) => {
  return axios.request({
    url: 'Favorites/GetFavoritesTree',
    method: 'GET',
    params: data,
  });
};

// 添加到收藏夹
export const addToFavorites = (data: any) => {
  return axios.request({
    url: 'Favorites/AddToFavorites',
    method: 'POST',
    data,
  });
};

// 取消收藏
export const cancelToFavorites = (data: any) => {
  return axios.request({
    url: 'Favorites/CancelToFavorites',
    method: 'POST',
    data,
  });
};
